export enum AllowedAdminUsernames {
  ANAS = 'anas',
  ANAS_EMAIL = 'anas@recyclee.io',
  ADMIN = 'admin',
  ABDULKARIM = 'abdulkarim',
}

export enum ReadOnlyAdminUsernames {
  R_BUKHARI = 'r.bukhari@sequencive.com',
  T_ALAQIL = 't.alaqil@recyclee.io',
  RAKAN = 'rakan@recyclee.io',
}

export enum UserRole {
  ADMIN = 'admin',
  RECYCLER = 'recycler',
  WASTE_OUTLET = 'waste_outlet',
  TRUCK_CO = 'truck_co',
  TRUCKER = 'trucker',
  WASTE_OUTLET_ADMIN = 'waste_outlet_admin',
  WASTE_OUTLET_OPS_MANAGER = 'waste_outlet_ops_manager',
  WASTE_OUTLET_STAFF = 'waste_outlet_staff',
  CHARITY_ADMIN = 'charity_admin',
  CHARITY_OPS_MANAGER = 'charity_ops_manager',
  CHARITY_STAFF = 'charity_staff',
  RECYCLER_ADMIN = 'recycler_admin',
  RECYCLER_OPS_MANAGER = 'recycler_ops_manager',
  RECYCLER_STAFF = 'recycler_staff',
  TRUCK_CO_ADMIN = 'truck_co_admin',
  TRUCK_CO_OPS_MANAGER = 'truck_co_ops_manager',
  TRUCK_CO_STAFF = 'truck_co_staff',
}

export interface LoginRequest {
  username?: string;
  phone?: string;
  password: string;
}

export interface LoginResponse {
    access_token: string;
    refresh_token: string;
}

export interface RefreshTokenRequest {
    refresh_token: string;
}

export interface UserData {
    permissions?: string[] | Record<string, string[]>;
    sites?: Record<string, string[]> | null;
    onesignal_player_id?: string;
    total_points?: number;
    first_name?: string | null;
    last_name?: string | null;
    gender?: string | null;
    nationality?: string | null;
    date_of_birth?: string | null;
    iban?: string | null;
    driver_license_expiry?: string | null;
    driver_license_number?: string | null;
    vehicle_registration_number?: string | null;
    employee_level?: 'Senior' | 'Mid' | 'Line' | null;
    permissions_legacy?: Record<string, string[]>;
    [key: string]: unknown;
}

export interface RegisterRequest {
    username: string;
    password: string;
    password_confirm: string;
    phone?: string | null;
    data: UserData;
}

export interface UserSchema {
    id?: string;
    sub?: string;
    username: string;
    email?: string;
    phone?: string | null;
    status?: 'active' | 'inactive';
    data?: UserData;
    created_at?: string;
    updated_at?: string;
    exp?: number;
    iat?: number;
}

export interface UpdateUserRequest {
    username?: string | null;
    phone?: string | null;
    status?: 'active' | 'inactive' | null;
    data?: Partial<UserData> | null;
}

export interface ForgotPasswordRequest {
    username: string;
    platform: "OPS" | "ZERO" | "360" | "ADMIN" | "MARKET";
}

export interface ResetPasswordRequest {
    token: string;
    new_password: string;
    new_password_confirm: string;
}

/** JWT access token payload — permissions at root after PR2 migration. */
export interface AuthTokenPayload {
    sub: string;
    username: string;
    typ: string;
    exp: number;
    iat: number;
    permissions: string[] | Record<string, string[]>;
  platform_permissions?: string[];
  sites?: Record<string, string[]>;
  is_pilot?: boolean;
}
